import { Location } from '@leid/api-locations'

export const getDirectionLink = (location: Location | undefined): string => {
  if (!location) {
    return ''
  }
  const latString = location.lat.toString().replace(',', '.')
  const longString = location.long.toString().replace(',', '.')

  const directionLink =
    location.googlePageLink ||
    `https://www.google.com/maps/dir/?api=1&destination=${latString},${longString}&travelmode=driving`
  return directionLink
}
